
  export function getFileExtenction(fileName){
    let extension;

    if(fileName){
      extension= fileName.split(".").pop().toUpperCase() ;
    }
    
    return extension;
  }

  // is file pdf
  export function isFilePdf(fileName){
    return getFileExtenction(fileName).toLowerCase() === 'pdf';
  }

  //change file name extension
  export function changeFileNameExtension(fileName,extension){    
    return fileName.substring(0, fileName.lastIndexOf("."))+"."+extension; 
  }

  export function base64ToArrayBuffer(base64) {
    let binary_string =  window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array( len );
    for (var i = 0; i < len; i++)        {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
